export const isFullStatic = false
export const staticPath = "/usr/src/app/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"